
import { ITestimonialText } from "@/models/vimy.models";
import { PropType } from "vue";
import { Options, Vue } from "vue-class-component";
import {translate} from "@/helpers/locale-helper";
import {DataStore} from "@/store";

@Options({
  components: {
  },
  props: {
    options: Object as PropType<ITestimonialText>,
  }
})
export default class MemorialText extends Vue {
  declare $refs: {
    scrollbar: HTMLElement,
    title: HTMLElement,
    wrapperScrollbar: HTMLElement
  }

  options!: ITestimonialText;

  get author() {
    if (!this.options.author) return '';
    // @ts-ignore
    return this.options.author[this.$i18n.locale];
  }

  get role() {
    // @ts-ignore
    return this.options.role[this.$i18n.locale];
  }

  get content() {
    // @ts-ignore
    return this.options.content[this.$i18n.locale];
  }

  get image() {
    // @ts-ignore
    return this.options.image[this.$i18n.locale];
  }

  get visitorThemeInfo() : string{
    // @ts-ignore
    const connnector = translate(this.$i18n.locale, 'testimonial.themeCountOf');


    const currTestimonialInfo = DataStore.currentTestimonialVisitorInfo;

    return [
      // @ts-ignore
      currTestimonialInfo.themeTitle,
      // @ts-ignore
      currTestimonialInfo.countTestimonialView,
      connnector,
      // @ts-ignore
      currTestimonialInfo.countTestimonial
    ].join(' ');

  }

  scrollbarHeight() {
    if (!this.$refs.wrapperScrollbar)
      return;

    const totalHeight = this.$refs.wrapperScrollbar.clientHeight;

    // @ts-ignore
    this.$refs.wrapperScrollbar.querySelector(".ps").style.height = totalHeight + 'px';

    // @ts-ignore
    this.$refs.scrollbar.update();
  }

  cutSpanTitle() {
    const stringText = this.$refs.title.textContent;

    if (!stringText || stringText.length < 1)
      return;

    stringText.split("");
    this.$refs.title.innerHTML = "";

    let i = 0, length = stringText.length;
    for (i; i < length; i++) {
        this.$refs.title.innerHTML += "<span>" + stringText[i] + "</span>";
    }
  }

  mounted() {
    this.cutSpanTitle();

    setTimeout(this.scrollbarHeight.bind(this), 1000);


    //console.log('MemorialVideo this.options', this.options);

    window.addEventListener("resize", this.onResize);
  }

  unmounted() {
    window.removeEventListener("resize", this.onResize);
  }

  private onResize(event: Event) {
    this.scrollbarHeight();
  }
}
